import { useEffect, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setNotification, setIsWeatherAlarmViaManagerMessage, setSubscriptionId, getData } from "../api/dataSlice"
import { isMobileApp, sendDataToMobileApp } from "./Utilities"

export default function MessageListener() {

    const dispatch = useDispatch()
    
    const { DEBUG, KEYCLOAK: { SERVER } } = window.conf
    const { subscriptionId, isWeatherAlarmViaManagerMessage } = useSelector(getData)

    const onPushData = (event) => {
        const payload = event.detail
        
        if (!payload || typeof payload !== 'object') {
            console.error('[MessageListener] Invalid payload: not an object')
            return
        }

        DEBUG && console.log(`[MessageListener] Incoming notification from mobile app: ${JSON.stringify(payload)}`)

        dispatch(setNotification(payload))
        isMobileApp && sendDataToMobileApp({ type: "removeNotification" })
    }

    const toOrigin = (url) => { try { return new URL(url, window.location.href).origin } catch { return null } }

    const toLocalOrigin = (origin) => {
        try {
            const { hostname } = new URL(origin)
            if (hostname === "localhost" || hostname === "127.0.0.1" || hostname === '::1') {
                return origin
            } else {
                return null
            }
        } catch {
            return null
        }
    }

    const disallowedOrigins = useRef(new Set([ // prevent re-renders
        toOrigin(SERVER), // Keycloak
        toLocalOrigin(window.location.origin) // local development
    ].filter(Boolean))).current

    const isAllowedDomain = (origin) => {
        try {
            const { hostname } = new URL(origin)
            return hostname === 'bautvplus.de' || hostname.endsWith('.bautvplus.de')
        } catch {
            return false
        }
    }

    const parseMessageData = (msg) => {
        if (msg && typeof msg === "object") return msg
        if (typeof msg === "string") {
            try { return JSON.parse(msg) } catch { return null }
        }
        return null
    }

    const onMessage = (event) => {

        if (disallowedOrigins.has(event.origin)) {
            return
        }

        // prevent Cross-Site-Scripting (XSS)
        if (!isAllowedDomain(event.origin)) {
            DEBUG && console.warn(`[MessageListener] Ignoring message from untrusted origin: ${event.origin} (expected: *.bautvplus.de)`)
            return
        }

        DEBUG && console.log(`[MessageListener] Incoming raw message from ${event.origin}: ${JSON.stringify(event.data)}`)

        let msg = parseMessageData(event.data)

        if (!msg || typeof msg !== "object" || !msg.type) {
            DEBUG && console.error(`[MessageListener] Invalid data from ${event.origin}: missing or invalid type`)
            return
        }

        DEBUG && console.log(`[MessageListener] Parsed message: ${JSON.stringify(msg)}`)

        if (msg.type === "alarm") {
            if (!isWeatherAlarmViaManagerMessage) {
                DEBUG && console.log(`[MessageListener] Setting IsWeatherAlarmViaManagerMessage to true`)
                dispatch(setIsWeatherAlarmViaManagerMessage(true))
            }
        }

        if (msg.type === "subscriptionId") {
            if (msg.data !== subscriptionId) {
                DEBUG && console.log(`[MessageListener] Setting Subscription ID:: ${msg.data}`)
                dispatch(setSubscriptionId(msg.data))
            }
        }   
    }

    useEffect(() => {
        window.addEventListener("pushData", onPushData)
        window.addEventListener("message", onMessage)
        return () => {
            window.removeEventListener("pushData", onPushData)
            window.removeEventListener("message", onMessage)
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return null
}